var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkGreencopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "59D87B00-A59D-4CD1-8B11-AB13D8090C2B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "23.553719%",
    x2: "0%",
    y2: "76.446281%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E99EF9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE53E4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "23.553719%",
    x2: "0%",
    y2: "76.446281%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26ECB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FCC93",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "10.497554 14.1995685 13.7203931 17.171521 20.7802238 10.6666667 23.2777778 12.969795 16.2237962 19.4746494 13.7203931 21.7777778 11.222839 19.4746494 8 16.5026969"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-T-P8-selected",
    transform: "translate(-266.000000, -335.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(98.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-checkmark-green",
    transform: "translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkGreencopy);
export default __webpack_public_path__ + "static/media/icon-checkmark-green copy.38985a45f2c3c934fb6d0424603ddc57.svg";
export { ForwardRef as ReactComponent };